import { bool, shape, string } from 'prop-types';

const errors = shape({
  agency: shape({
    subId: string.isRequired,
  }).isRequired,
  backEnd: shape({}),
  customerInfo: shape({}),
  finalCleaning: bool.required,
  payment: shape({}),
  termsAndConditions: string.isRequired,
  voucher: string.isRequired,
});

export { errors as default };
